<template>
    <main id="content">
        <div class="container">
            <h1>Willkommen beim Geschenk-O-Mat!</h1>

            <section id="products">
                <div class="box">
                    <img alt="test" src="https://via.placeholder.com/350" />
                    <h3>Testprodukt</h3>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,</p>
                    <a href="/">Mehr erfahren »</a>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'Content',
    }
</script>

<style scoped>
    .box {
        margin: 75px auto;
        max-width: 350px;
    }
</style>